var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mbm-plot-content row" }, [
    !!this.selectedSplice
      ? _c("div", [
          _c("h4", [
            _vm._v(
              "Splicing event data for " +
                _vm._s(this.exonData[0].gene_name) +
                ", " +
                _vm._s(this.spliceData[0].tissue)
            ),
          ]),
          _vm._m(0),
        ])
      : _c("div", [
          _vm._v(" Select a splice track to view from the table below. "),
        ]),
    _c("div", { staticClass: "col-md-10" }, [
      !!this.selectedSplice
        ? _c("div", [
            _c("strong", [
              _vm._v(
                _vm._s(this.exonData[0].gene_name) +
                  " " +
                  _vm._s(this.exonData[0].strand)
              ),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "genes-plot-wrapper",
          attrs: { id: "spliceTrackWrapper" + _vm.sectionId },
        },
        [
          _c("canvas", { attrs: { id: `xaxis_${_vm.sectionId}` } }),
          _c("canvas", {
            class: !_vm.exonData ? "hidden" : "",
            attrs: { id: "spliceTrack" + _vm.sectionId, width: "", height: "" },
            on: { resize: _vm.onResize, mousemove: _vm.checkPosition },
          }),
        ]
      ),
    ]),
    _c("div", { staticClass: "col-md-2" }, [
      !!this.selectedSplice
        ? _c("div", { staticClass: "highlighted-data" }, [
            _c("strong", [_vm._v("Highlighted splicing event:")]),
            _c("div", { attrs: { id: "spliceData" } }, [
              this.hoverTent !== -1
                ? _c("div", [
                    _c("div", [
                      _vm._v("Chromosome: " + _vm._s(this.hoverTentData.chr)),
                    ]),
                    _c("div", [
                      _vm._v(
                        "Start position: " +
                          _vm._s(this.hoverTentData.splice_start)
                      ),
                    ]),
                    _c("div", [
                      _vm._v(
                        "End position: " + _vm._s(this.hoverTentData.splice_end)
                      ),
                    ]),
                    _c("div", [
                      _vm._v("Gene ID: " + _vm._s(this.hoverTentData.gene_id)),
                    ]),
                    _c("div", [
                      _vm._v(
                        "Gene symbol: " + _vm._s(this.exonData[0].gene_name)
                      ),
                    ]),
                    _c("div", [
                      _vm._v("Tissue: " + _vm._s(this.hoverTentData.tissue)),
                    ]),
                    _c("div", [
                      _vm._v(
                        "Cluster ID: " +
                          _vm._s(_vm.getClusterID(_vm.hoverTentData.full_id))
                      ),
                    ]),
                  ])
                : _c("div", [
                    _vm._v(
                      "Hover over the diagram to highlight a splicing event."
                    ),
                  ]),
            ]),
            _c("strong", [_vm._v("Highlighted exon:")]),
            this.hoverExon !== -1
              ? _c("div", [
                  _c("div", [
                    _vm._v("Chromosome: " + _vm._s(this.hoverExonData.chr)),
                  ]),
                  _c("div", [
                    _vm._v(
                      "Start position: " + _vm._s(this.hoverExonData.exon_start)
                    ),
                  ]),
                  _c("div", [
                    _vm._v(
                      "End position: " + _vm._s(this.hoverExonData.exon_end)
                    ),
                  ]),
                  _c("div", [
                    _vm._v("Gene ID: " + _vm._s(this.hoverExonData.gene_id)),
                  ]),
                  _c("div", [
                    _vm._v(
                      "Gene symbol: " + _vm._s(this.hoverExonData.gene_name)
                    ),
                  ]),
                ])
              : _c("div", [
                  _vm._v("Hover over the diagram to highlight an exon."),
                ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", { attrs: { id: "explanation" } }, [
      _c("li", [
        _vm._v(
          "Rectangles represent exons. Hover to highlight splicing events overlapping the exon."
        ),
      ]),
      _c("li", [
        _vm._v(
          "Dot-and-line symbols represent splicing events. Hover over the dot to highlight exons overlapping the splicing event."
        ),
      ]),
      _c("li", [
        _vm._v(
          "The splicing event indicated by an arrow corresponds to the selected row from the table."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }